import React from "react";
import cx from "classnames";

import styles from "./simple-table.module.scss";
import { Card } from "../Card/Card";
import { TitleBar } from "../TitleBar/TitleBar";
import { IterationItem } from "../IterationItem/IterationItem";

export namespace SimpleTable {
  export type Props = React.HTMLAttributes<HTMLTableElement> & {
    size?: "small" | "medium";
    fixedHeader?: boolean;
  };
}

const TableContext = React.createContext<{
  size?: "small" | "medium";
  fixedHeader?: boolean;
}>({});

export const SimpleTable = ({
  children,
  className,
  fixedHeader = false,
  size = "medium",
  ...props
}: SimpleTable.Props): JSX.Element => (
  <TableContext.Provider value={{ size, fixedHeader }}>
    <Card className={className} padding={0} elevation={1} {...props}>
      <table className={styles.simpleTable}>{children}</table>
    </Card>
  </TableContext.Provider>
);

export const Thead = (
  props: React.HTMLAttributes<HTMLTableSectionElement>
): JSX.Element => <thead {...props} />;

export const Tfoot = (
  props: React.HTMLAttributes<HTMLTableSectionElement>
): JSX.Element => <tfoot {...props} />;

export const Tbody = (
  props: React.HTMLAttributes<HTMLTableSectionElement>
): JSX.Element => <tbody {...props} />;

export const Tr = ({
  onClick,
  ...props
}: React.HTMLAttributes<HTMLTableRowElement> & {
  onClick?: (event: React.MouseEvent) => void;
}): JSX.Element => (
  <tr
    {...props}
    className={cx(onClick && styles.simpleTableTrClickable)}
    onClick={onClick}
  />
);

export const Th = (
  props: React.HTMLAttributes<HTMLTableHeaderCellElement>
): JSX.Element => {
  const { size, fixedHeader } = React.useContext(TableContext);

  return (
    <TitleBar
      {...props}
      className={cx(fixedHeader && styles.simpleTableThSticky)}
      as="th"
      size={size}
    />
  );
};

export const Td = (
  props: React.HTMLAttributes<HTMLTableCellElement> & { hasChildren?: boolean }
): JSX.Element => {
  const { size } = React.useContext(TableContext);

  return <IterationItem {...props} as="td" size={size} />;
};
